export default __webpack_public_path__ + "static/media/payroll.35dde6cd.png";